// extracted by mini-css-extract-plugin
export default {"callOutQuote":"CalloutQuote_callOutQuote__5Ljl3"};